export default __webpack_public_path__ + "static/media/f4.915ce1d1.jpg";